import React, { useState } from 'react';
import { Field, Form } from 'redux-form';
import { withStyles } from 'material-ui';
import Typography from 'material-ui/Typography';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Checkbox, required, countries, DropDownMenu } from 'entoro-shared';
const styles = () => ({
  container: {
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

function CountryOfResidence({
  handleSubmit,
  offer,
  investorUser: { country },
}) {
  return (
    <Form onSubmit={handleSubmit}>
      <div style={{ maxWidth: '100%' }}>
        <Typography
          style={{ fontSize: '1rem', marginLeft: '20px', marginBottom: '20px' }}
        >
          <strong>Current Country:</strong>{' '}
          <span name='country'>{countries.getLabel(country)}</span>
        </Typography>

        <Field
          component={DropDownMenu}
          name='countryOfResidence'
          label='Change Country'
          options={countries.options}
          onChange={(el, val) => {
            if (
              offer.locationsToExclude &&
              offer.locationsToExclude.includes(val)
            ) {
              const MySwal = withReactContent(Swal);
              const result = MySwal.fire({
                title: 'Thank you for your interest',
                text: ' This deal is not available for Investors in the selected country.',
                icon: 'warning',
                confirmButtonColor: '#808080',
                cancelButtonColor: '#d33',
                showCancelButton: true,
                confirmButtonText: `See Disclaimer`,
                cancelButtonText: `Back`,
                customClass: {
                  container: 'myswalcontainer',
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = '/offer-disclaimer';
                } else if (result.isDismissed) {
                  return false;
                }
              });
              if (result.isConfirmed) {
                window.location.href = '/offer-disclaimer';
              } else if (result.isDismissed) {
                return false;
              }
            }
            // document.getElementById('country').textContent =
            //   countries.getLabel(val);
          }}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='confirmCountryOfResidence'
          label={`Confirm country of residence `}
        />
      </div>
      <br />
    </Form>
  );
}

export default withStyles(styles)(CountryOfResidence);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/CountryOfResidence.js